module.exports = __webpack_public_path__ + "static/item-8-28b2ec1c05cd81f3da9a6bc21bb688e0.jpeg";